export { MovimientosCamionIndex } from "./container/index";



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscamion/index.tsx